import { css } from 'styled-components';
import { CFTokens } from '../../../tokens';
import { CFBaseAvatarTokens, CFBaseAvatarUtils } from '.';
export const avatarSize = ({ $size = 'md' }) => {
    if (typeof $size === 'number') {
        return css `
      height: ${$size}px;
      width: ${$size}px;
    `;
    }
    const numericSize = CFBaseAvatarUtils.getAvatarSize($size);
    return css `
    height: ${numericSize}px;
    width: ${numericSize}px;
  `;
};
export const backgroundColor = ({ $backgroundColor, $colorway, }) => {
    return CFTokens.getCFColorValue($backgroundColor, CFBaseAvatarTokens.COLORWAYS[$colorway].BACKGROUND);
};
export const border = ({ $border }) => {
    if (!$border)
        return null;
    const borderColor = $border === true
        ? CFBaseAvatarTokens.BORDER_COLOR
        : CFTokens.getCFColorValue($border, CFBaseAvatarTokens.BORDER_COLOR);
    return css `
    border: 1px solid ${borderColor};
  `;
};
export const borderRadius = ({ $size, $shape }) => {
    if ($shape === 'circle')
        return CFBaseAvatarTokens.BORDER_RADII_CIRCLE;
    if ($shape === 'squircle')
        return CFBaseAvatarUtils.getSquircleBorderRadius($size);
    return 0;
};
export const fontSize = ({ $size = 'md' }) => CFBaseAvatarUtils.getFontSize($size);
export const initialsColor = ({ $colorway, $initialsColor, }) => {
    return CFTokens.getCFColorValue($initialsColor, CFBaseAvatarTokens.COLORWAYS[$colorway].INITIALS);
};
